















































import { Component, Mixins, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Resource } from '@/modules/backend/Entities/Resource';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { resolveModule } from '@/store';
import { CreateProviderData } from '@/modules/backend/Dto/CreateProviderData';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';

const ResourcesModule = namespace('dashboard/resources');
@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class ProviderAddDialog extends Mixins(Mixin) {
  private get resources(): Array<Resource> {
    return this.resourcesList;
  }

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  private readonly providers: ProvidersModule = resolveModule(ProvidersModule);

  @ResourcesModule.Action('Fetch')
  private readonly fetchResources!: () => Promise<void>;

  @ResourcesModule.Getter('Resources')
  private readonly resourcesList!: Resource[];

  private form: CreateProviderData = new CreateProviderData({
    name: '',
    resourceIds: []
  });

  public async mounted(): Promise<void> {
    await this.fetchResources();
  }

  private async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      await this.providers.create(this.form);
    } else {
      throw new Error('Validation error');
    }
  }

  private clearForm(): void {
    this.observer.reset();
    this.form.name = '';
    this.form.resourceIds = [];
  }

  private dialogOpenHandler(): void {
    this.clearForm();
  }
}
